import APIEntry from "@/api/APIEntry.js";
import { CONFIG } from "@/datas/configs.js";
import axios from "axios";
import store from "../store";

/**
 * Global mapping interfaces
 */
export default Object.freeze({
  /**
   * api entry 매칭 시키기
   */
  entry: function() {
    if (!arguments.length) {
      return null;
    }
    let args = [];
    Array.prototype.push.apply(args, arguments);

    let match = store.state.entries[args[0]];

    if (typeof match == "undefined") {
      return null;
    }
    args.shift();

    let mallId = store.state.mallId;
    let appCode = store.state.appCode;

    if (!mallId || !appCode) {
      return null;
    }

    args.unshift(mallId);
    args.unshift(appCode);

    let uri = match.path;

    args.map((item, index) => {
      let search = `{${index}}`;
      uri = uri.replace(search, item);
    });

    return new APIEntry(uri, match.method);
  },
  /**
   * api request
   * @param {APIEntry} entry API URI 맵핑 객체
   * @param {Object} payload 요청 본문 파라미터
   */
  api: async function(entry, payload) {
    if (entry === null) {
      throw new Error("'entry' parameter is required.");
    }
    // status code 확인 하여 토큰 갱신 처리
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.interceptors.response.use(null, async (error) => {
      if (error.config && error.response && error.response.status === 401) {
        await store.dispatch("REFRESH_ACCESS_TOKEN", store);
        error.config.headers.Authorization = store.state.accessToken;
        return axios.request(error.config);
      }
      return Promise.reject(error);
    });

    let statement = {
      baseURL: CONFIG.API_HOST,
      url: entry.getPath(),
      method: entry.getMethod(),
    };

    if (payload) {
      if (["POST", "DELETE", "PUT"].includes(entry.getMethod())) {
        statement.data = payload;
      } else {
        statement.params = payload;
      }
    }

    let res = await axios(statement);

    return res.data;
  },
  /**
   * date 포멧
   * @param {new Date} date
   */
  yyyymmdd: function(date) {
    let yyyy = date.getFullYear().toString();
    let mm = (date.getMonth() + 1).toString();
    let dd = date.getDate().toString();
    return (
      yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0])
    );
  },

  phoneNumberCheck: function(e) {
    let val = e.target.value;
    if (isNaN(val)) {
      e.target.value = "";
    } else {
      e.target.value = val;
    }

    if (val.length > 12) {
      e.target.value = val.replace(/[^0-9]/g, "").slice(0, -1);
    }

    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  /**
   * 숫자만 입력 체크
   */
  checkNumber: function(e) {
    if (
      e.keyCode == 69 ||
      e.keyCode == 190 ||
      e.keyCode == 109 ||
      e.keyCode == 189
    ) {
      e.preventDefault();
      return false;
    }
  },
  replaceNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1);
    e.target.value = chkNumber === true ? Number(replaceVal) : replaceVal;
    if (chkNumber === true && e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  replaceCommaNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;

    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1) * 1;
    e.target.value =
      chkNumber === true
        ? Number(replaceVal)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : replaceVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });

    e.target.dispatchEvent(event);
  },
  textCounter: function(e, max) {
    let val = e.target.value;

    if (val.length >= max) {
      let str = val.substring(0, max);
      e.target.value = str;
      return false;
    } else {
      e.target.value = val;
      var event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      e.target.dispatchEvent(event);
    }
  },
  replaceDateCount: function(e, type) {
    let val = e.target.value;
    let max = type === "y" || type === "m" ? 2 : 3;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max);
    e.target.value = Number(replaceVal);
    if (e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  urlPath: function() {
    let pathArray = window.location.pathname.split("/");
    return pathArray[1];
  },
  isPhoneNumber: function(phone_number) {
    let regExp = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
    let result = regExp.test(phone_number);
    return result;
  },
  isMail: function(mail) {
    let regExp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
    let result = regExp.test(mail);
    return result;
  },
});
